import { createContext, useContext, useState, useCallback } from "react";
import api from "../utils/api";

const ImpersonationContext = createContext(null);

// Start / end are written to the audit trail by the backend (POST /api/audit/impersonation) —
// the browser can't write audit records itself
const logImpersonation = (action, targetUid) =>
  api.post("/api/audit/impersonation", { action, targetUid }).catch(err => console.error(`Failed to log impersonation ${action}:`, err));

export function ImpersonationProvider({ children }) {
  const [impersonation, setImpersonation] = useState(null);
  // impersonation shape: { uid, name, email, role, companyId, startTime }

  const startImpersonation = useCallback(async (targetUser) => {
    await logImpersonation("start", targetUser.uid);
    setImpersonation({
      uid: targetUser.uid,
      name: targetUser.name || targetUser.email,
      email: targetUser.email,
      role: targetUser.role,
      companyId: targetUser.companyId || null,
      userPermissions: targetUser.userPermissions || [],
      features: targetUser.features || {},
      enabledModules: targetUser.enabledModules || null,
      startTime: new Date(),
    });
  }, []);

  const endImpersonation = useCallback(async () => {
    if (impersonation?.uid) await logImpersonation("end", impersonation.uid);
    setImpersonation(null);
  }, [impersonation]);

  return (
    <ImpersonationContext.Provider value={{ impersonation, startImpersonation, endImpersonation }}>
      {children}
    </ImpersonationContext.Provider>
  );
}

export function useImpersonation() {
  const ctx = useContext(ImpersonationContext);
  if (!ctx) throw new Error("useImpersonation must be used inside ImpersonationProvider");
  return ctx;
}
